module.exports = __webpack_public_path__ + "img/home_icon1.b6e2ef5e.png";